import { Action } from 'redux';
import { put, select } from '@redux-saga/core/effects';

import { AppState } from 'store';
import { BasketSagaReturnType, callBasketSaga } from 'store/sagaHelpers';
import { BasketActionTypes } from 'store/basket';
import { PaymentActionTypes } from 'store/payment';
import { loadBasketSaga, validateBasketReservationsSaga, validateCartSaga } from 'store/basket/actions';
import { ACTION_CREATOR_NAME } from 'helpers';

export interface ValidateBeforePaymentAction extends Action<PaymentActionTypes.VALIDATE_BEFORE_PAYMENT> {
    onSuccess: () => void;
    onError: () => void;
}

export interface ValidateBeforePaymentActionStart extends Action<PaymentActionTypes.VALIDATE_BEFORE_PAYMENT_START> {
}

export interface ValidateBeforePaymentActionSuccess extends Action<PaymentActionTypes.VALIDATE_BEFORE_PAYMENT_SUCCESS> {
}

export interface ValidateBeforePaymentActionError extends Action<PaymentActionTypes.VALIDATE_BEFORE_PAYMENT_ERROR> {
}

export const validateBeforePayment: (onSuccess: () => void, onError: () => void) => ValidateBeforePaymentAction = (onSuccess: () => void, onError: () => void) => ({
    type: PaymentActionTypes.VALIDATE_BEFORE_PAYMENT,
    onSuccess,
    onError
});
validateBeforePayment[ACTION_CREATOR_NAME] = 'validateBeforePayment';
export type ValidateBeforePaymentFunc = (...args: Parameters<typeof validateBeforePayment>) => void;

export function* validateBeforePaymentSaga({ onSuccess, onError }: ValidateBeforePaymentAction): BasketSagaReturnType {
    try {
        yield put<ValidateBeforePaymentActionStart>({
            type: PaymentActionTypes.VALIDATE_BEFORE_PAYMENT_START
        });

        yield callBasketSaga(loadBasketSaga);

        yield callBasketSaga(validateBasketReservationsSaga, {
            type: BasketActionTypes.VALIDATE_BASKET_RESERVATIONS,
            isBasketPage: false
        });

        yield callBasketSaga(validateCartSaga, {
            type: BasketActionTypes.VALIDATE_CART,
            isBasketPage: false
        });

        const state: AppState = yield select();
        const { basket, validationResult, shouldShowReservationWarning } = state.basketState;

        const isValid = basket && validationResult.isValid && !shouldShowReservationWarning;

        if (!isValid) {
            onError();

            yield put<ValidateBeforePaymentActionSuccess>({
                type: PaymentActionTypes.VALIDATE_BEFORE_PAYMENT_SUCCESS
            });

            return true;
        }

        onSuccess();

        yield put<ValidateBeforePaymentActionSuccess>({
            type: PaymentActionTypes.VALIDATE_BEFORE_PAYMENT_SUCCESS
        });

        return true;
    } catch (error) {
        onError();

        yield put<ValidateBeforePaymentActionError>({
            type: PaymentActionTypes.VALIDATE_BEFORE_PAYMENT_ERROR
        });

        return false;
    }
}